/* eslint-disable */
import { ApiPost } from '../util/axios'
import { consoleLog } from '../util'

const resetPassword1Api = async data => {
  const options = {
    reqId: 'GetUserPasscode',
    payload: { email: data.email },
    resId: 'GetUserPasscodeResponse',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const resetPassword2Api = async data => {
  const options = {
    reqId: 'SetUserPasswordForgotPassword',
    payload: { email: data.email, newPassword: data.newPassword },
    resId: 'SetUserPasswordForgotPasswordResult',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const changePasswordFirstTimeApi = async data => {
  const options = {
    reqId: 'SetUserPasswordFirstTimeLogIn',
    payload: { email: data.email, newPassword: data.newPassword },
    resId: 'SetUserPasswordFirstTimeLogInResponse',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const changePasswordApi = async data => {
  const options = {
    reqId: 'SetUserPassword',
    payload: { email: data.email, currentPassword: data.currentPassword, newPassword: data.newPassword },
    resId: 'SetUserPasswordResponse',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const loginApi = async data => {
  const options = {
    reqId: 'GetUser',
    payload: { emailAddress: data.email, userTypeId: 1 },
    resId: 'GetUserResult',
    resType: 'object'
  }
  return await ApiPost(options).then( async (res) => {
    if (res?.UserId) {
      const options1 = {
        reqId: 'GetEncryptedPassword',
        payload: { password: data.password, passwordSalt: res.PasswordSalt },
        resId: 'GetEncryptedPasswordResult',
        resType: 'object'
      }
      const getPassword = await ApiPost(options1)
      if(getPassword === res.EncryptedPassword) {
        const options = {
          reqId: 'GetAdminPasswords',
          payload: { },
          resId: 'GetAdminPasswordsResult',
          resType: 'object'
        }
        return await ApiPost(options).then( async (passwordRes) => {
          const timeStamp = new Date()
          const response = { ...res, loginTime: timeStamp, userWords: passwordRes.join(',') || []}
          window.localStorage.setItem('user', JSON.stringify(response))
          // window.localStorage.setItem('logssss', JSON.stringify([]))
          
          const options_SetAdminUserLog = {
            reqId: 'SetAdminUserLog',
            payload: { userEmail: data.email, userIP: res.UserIP || '192.168.1.22' },
            resId: 'SetAdminUserLogResponse',
            resType: 'object'
          }
  
          return await ApiPost(options_SetAdminUserLog).then((resp) => {
            return organizationDetailsApi(res)
          },
          (error) => {
            consoleLog('error - ', error)
          })
  
        },
        (error) => {
          consoleLog('error - ', error)
        })
      } else {
        return {}
      }
      // return res
    }
    return {}
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const authorizeApi = async data => {
  const options = {
    reqId: 'GetUser',
    payload: { email: data.email, password: data.password },
    resId: 'GetUserResult',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    if (res?.UserId) {
      const timeStamp = new Date()
      const response = { ...res, loginTime: timeStamp, devMode: res.CompanyId === 'e0804536-45e9-11ed-bca4-0a1ea4c5532f'}
      window.localStorage.setItem('user', JSON.stringify(response))
      // window.localStorage.setItem('logssss', JSON.stringify([]))
      // return 'Login Success'
      return organizationDetailsApi(response)
    }
    return {}
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getSSOUserApi = async data => {
  const options = {
    reqId: 'GetSSOUser',
    payload: data,
    resId: 'GetSSOUserResult',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    if (res?.UserId) {
      const timeStamp = new Date()
      const response = {...res, loginTime:timeStamp, devMode: false}
      window.localStorage.setItem('user', JSON.stringify(response))
      // window.localStorage.setItem('logssss', JSON.stringify([]))
      // return 'Login Success'
      return organizationDetailsApi(response)
    }
    return {}
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getSSOLogInUrlApi = async data => {
  const options = {
    reqId: 'GetSSOLogInUrl',
    payload: data,
    resId: 'GetSSOLogInUrlResult',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const organizationDetailsApi = async data => {
  const options = {
    reqId: 'GetOrganization',
    payload: { webName: data.OrganizationUsers.OrganizationWebName },
    resId: 'GetOrganizationResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    window.localStorage.setItem('company', JSON.stringify(res))
    return { user: data, company: res }
    // return getOrganizationAggregationTabsApi({ user: data, company: res })
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationTabsApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationTabs',
    payload: { organizationId: data.organizationId },
    resId: 'GetOrganizationAggregationTabsResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    window.localStorage.setItem('organizationAggregationTabs', JSON.stringify(res))
    return {...data, tabDetails:res}
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getAggregationItemsForOrganizationApi = async (data) => {
  const options = {
    reqId: 'GetAggregationItemsForOrganization',
    payload: data,
    resId: 'GetAggregationItemsForOrganizationResult',
    resType: 'object',
    getLatest: true
  }
  const response = await ApiPost(options)
  return response
}

const getOrganizationAggregationItemApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationItem',
    payload: data,
    resId: 'GetOrganizationAggregationItemResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const validateCompanyIdApi = async data => {
  const options = {
    reqId: 'GetCompany',
    payload: { userId: data.UserId },
    resId: 'GetCompanyResult',
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    window.localStorage.setItem('company', JSON.stringify(res))
    // return data
    return { user: data, company: res }
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getFlipItemHotlistBitForOrganizationApi = async data => {
  const options = {
    reqId: 'FlipItemHotlistBitForOrganization',
    payload: data,
    resId: 'FlipItemHotlistBitForOrganizationResponse',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getFlipItemBookmarkBitForOrganizationApi = async data => {
  const options = {
    reqId: 'FlipItemBookmarkBitForOrganization',
    payload: data,
    resId: 'FlipItemBookmarkBitForOrganizationResponse',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setPerformActionOnAggregationItemsForOrganizationApi = async data => {
  const options = {
    reqId: 'PerformActionOnAggregationItemsForOrganization',
    payload: data,
    resId: 'PerformActionOnAggregationItemsForOrganizationResponse',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  loginApi,
  authorizeApi,
  getSSOUserApi,
  getSSOLogInUrlApi,
  validateCompanyIdApi,
  resetPassword1Api,
  resetPassword2Api,
  changePasswordApi,
  changePasswordFirstTimeApi,
  getOrganizationAggregationTabsApi,
  getAggregationItemsForOrganizationApi,
  getOrganizationAggregationItemApi,
  getFlipItemHotlistBitForOrganizationApi,
  getFlipItemBookmarkBitForOrganizationApi,
  setPerformActionOnAggregationItemsForOrganizationApi
}